<template>
  <div id="employee" v-if="userInfo.userType === 'kefu' && showEmployeeDialog">
    <div id="center-content-300" v-if="!readyLoginLoading">
      <!-- ========================= 主视觉 ========================= -->
      <i class="el-icon-s-custom" />
      <h3>员工打卡</h3>
      <el-select
        style="width: 100%; margin-top: 16px"
        size="small"
        v-model="loginObj.employeeId"
        placeholder="永强"
        @change="loginObj.verifyCode = null"
      >
        <el-option
          v-for="option in dataList"
          :key="option.id"
          :label="option.employeeName"
          :value="option.id"
        />
      </el-select>
      <el-input
        style="width: 100%; margin-top: 16px"
        size="small"
        v-model.trim="loginObj.verifyCode"
        placeholder="thisIsPassword"
        @keyup.enter.native="submitClockIn()"
      >
        <el-button
          @click="submitClockIn()"
          slot="append"
          icon="el-icon-right"
        ></el-button>
      </el-input>
      <p id="wrap-sign-in-out">
        <span class="item" @click="logout()">取消</span>
        <span class="item" @click="submitClockIn()">登入</span>
      </p>
      <p id="another-domain">{{ poem || "" }}</p>
    </div>
    <!-- ========================= 准备登入 loading ========================= -->
    <div id="center-content" v-else>
      <!-- 主视觉 -->
      <i class="el-icon-s-custom" />
      <h3>{{ isClockInEmployeeName }}</h3>
      <h4><i class="el-icon-loading" /> Please wait for respond.</h4>
    </div>

    <!-- 确认登出目前正在上班员工弹框 -->
    <div v-if="confirmForceDialog" class="wrap-sign-in">
      <div class="title">
        网页 后台登入
        <i class="el-icon-close" @click="confirmForceDialog = false" />
      </div>
      <div class="sub-title">若您要登入打卡，请选择断开连结一个用户。</div>
      <div class="third-title">目前过多用户登入在线。</div>
      <div class="logined-user" @click="clockInEmployee()">
        <div>
          <i class="el-icon-right" />
          <span>DSY-WEB-员工 / {{ isClockInEmployeeName }}</span>
        </div>
        <div>在线</div>
      </div>
      <div class="bottom-area">
        强制断开此位用户
        <span @click="confirmForceDialog = false" class="cancel">取消</span>
      </div>
    </div>
  </div>
</template>

<script>
import varCommon from "@/utils/varCommon";
import mainCommon from "@/utils/mainCommon";
import Cookies from "js-cookie";
import {
  getAllEmployee, // 取得员工档资料
  getEmployClockStatus, // 取得当前员工值班状态
  clockInEmployee, // 开始员工值班
} from "@/api/user";

export default {
  mixins: [mainCommon],
  data() {
    return {
      showEmployeeDialog: true,
      listLoading: false,
      dataList: null, // 员工列表
      loginObj: {
        employeeId: null,
        verifyCode: null,
      },
      readyLoginLoading: false, // 准备登入
      confirmForceDialog: false, // 强制登入并登出线上员工
      isClockInEmployeeName: null, // 当前正在上班的员工
      poem: null,
    };
  },
  created() {
    if (this.userInfo.userType === "kefu") {
      this.checkClockInUserIsSelf();
      this.getAllEmployee();

      let poemArray = [
        "Amor est vitae essentia", // 爱为生命之本
        "Carpe diem", // 抓住今天
        "Cogito ergo sum", // 我思故我在
        "Ipsa scientia potestas est", // 知识即权力
        "Nec hostium timete, nec amicum reusate", // 不畏敌人，不拒朋友
        "Nil desperandum", // 不要绝望
        "Qui tacet consentit", // 沉默即默认
        "Sic transit gloria mundi", // 世间荣耀转瞬即逝
        "Vade in pace", // 一路平安
        "Justitia nemini neganda est", // 任何人都应得到公正的对待
        "Pax et justitia", // 和平与正义
      ];
      this.poem = poemArray[Math.floor(Math.random() * poemArray.length)];
    }
  },
  methods: {
    // 确认目前线上是否自己在上班(因为页面刷新或其它原因导致)，若"是"则不需要再打卡
    checkClockInUserIsSelf() {
      getEmployClockStatus(this.userInfo.userId).then((res) => {
        this.$store.commit("SET_EMPLOYEE_OBJ", res.data);
        this.isClockInEmployeeName = res.data.employeeName;
        let eeyolpme = Cookies.get("eeyolpme");
        // 如果有 cookie 且 cookie 记录的 eeyolpme 与现在上班的员工相同，就不需显示打卡弹框了
        if (
          eeyolpme &&
          eeyolpme.toString() === res.data.employeeId.toString()
        ) {
          this.readyLoginLoading = true;
          setTimeout(() => {
            this.showEmployeeDialog = false;
          }, 600);
        }
      });
    },
    // 取得此客服可登入的员工列表
    getAllEmployee() {
      this.listLoading = true;
      getAllEmployee()
        .then((res) => {
          this.dataList = res.data;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    // 打卡
    submitClockIn() {
      if (!this.loginObj.employeeId) {
        return this.$notify.error("亲，请记得选择用户！");
      }
      if (!this.loginObj.verifyCode) {
        return this.$notify.error("亲，验证码不可为空！");
      }
      // 打卡的时候确认是否有人在上班，有则跳弹框告知会把对方登出
      getEmployClockStatus(this.userInfo.userId).then((res) => {
        this.$store.commit("SET_EMPLOYEE_OBJ", res.data);
        this.isClockInEmployeeName = res.data.employeeName;
        if (
          res.data.employeeId &&
          res.data.employeeId !== this.loginObj.employeeId
        ) {
          this.confirmForceDialog = true;
        } else {
          this.clockInEmployee();
        }
      });
    },
    // 开始上班接口
    clockInEmployee() {
      this.readyLoginLoading = true;
      this.confirmForceDialog = false;
      clockInEmployee(this.loginObj)
        .then(() => {
          getEmployClockStatus(this.userInfo.userId).then((res) => {
            this.$store.commit("SET_EMPLOYEE_OBJ", res.data);
            this.isClockInEmployeeName = res.data.employeeName;
          });
          setTimeout(() => {
            // 登入成功，写 cookie
            Cookies.set("eeyolpme", this.loginObj.employeeId);
            this.readyLoginLoading = false;
            this.showEmployeeDialog = false;
          }, 600);
        })
        .catch(() => {
          this.readyLoginLoading = false;
        });
    },
    // 不打卡，直接登出
    logout() {
      this.$confirm("确定登出？", varCommon.message.warning, {
        confirmButtonText: varCommon.message.confirm,
        cancelButtonText: varCommon.message.cancel,
        type: "error",
      })
        .then(() => {
          this.$store.dispatch("LogOut").then(() => {
            location.reload();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
#employee {
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: #053154;
  // opacity: 0.96;
  z-index: 2000;
  #center-content-300 {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 15vh;
    text-align: center;
    width: 300px;
  }
  #center-content {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 15vh;
    text-align: center;
    width: 100%;
  }
  .el-icon-s-custom {
    color: #fff;
    font-size: 160px;
    background-color: #3e6e8f;
    padding: 20px;
    border-radius: 50%;
    margin: 0 auto;
  }
  h3 {
    color: #fff;
    font-size: 45px;
    font-weight: 400;
    margin: 20px auto 10px;
  }
  h4 {
    color: #fff;
    font-size: 30px;
    font-weight: 400;
    margin: 40px auto 10px;
  }
  #wrap-sign-in-out {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
  }
  #wrap-sign-in-out .item {
    cursor: pointer;
    font-size: 17px;
    color: #eef4fa;
  }
  #another-domain {
    font-size: 17px;
    color: #95b4c6;
  }
  .wrap-sign-in {
    position: absolute;
    left: 50%;
    top: 30vh;
    transform: translateX(-50%);
    background-color: #fff;
    width: 380px;
    border: 1px solid #939393;
    .title {
      padding: 6px;
      font-size: 13px;
      .el-icon-close {
        float: right;
        cursor: pointer;
      }
    }
    .sub-title {
      margin-top: 10px;
      padding: 6px;
      color: #3575c6;
      font-size: 15px;
    }
    .third-title {
      margin-top: 10px;
      padding: 6px;
      font-size: 13px;
    }
    .logined-user {
      border: 1px solid #afdfff;
      color: #219aec;
      font-size: 13px;
      width: 98%;
      margin: 10px auto 0;
      padding: 10px;
      cursor: pointer;
      &:hover {
        border: 1px solid #e4e4e4;
      }
      i {
        font-size: 16px;
        font-weight: 600;
      }
      div:nth-child(2) {
        margin-top: 26px;
        margin-left: 18px;
      }
    }
    .bottom-area {
      font-size: 13px;
      margin-top: 40px;
      padding: 10px 6px;
      background-color: #f8f3f7;
      border-top: 1px solid #cacaca;
      .cancel {
        font-size: 13px;
        border: 1px solid #cacaca;
        padding: 2px 15px;
        float: right;
        background-color: #e8e3e8;
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/Employee.vue